const initProductAccordionVideo = () => {
  const videoWrapper = document.querySelector('[data-custom-video-wrapper]');

  if (!videoWrapper) {
    return;
  }

  const video = videoWrapper.querySelector('video');
  const playButton = videoWrapper.querySelector('[data-custom-video-play-btn]');

  if (video && playButton) {
    playButton.addEventListener('click', () => {
      video.muted = false;
      video.play();
    });

    video.addEventListener('click', () => {
      if (!video.paused) {
        video.pause();
      }
    });

    video.addEventListener('pause', () => {
      playButton.classList.remove('hidden');
    });

    video.addEventListener('play', () => {
      playButton.classList.add('hidden');
    });
  }
};

export default initProductAccordionVideo;
